<!-- Spinner -->

<!-- Content -->
@if ({pois: (slideViewerFacade.currentSelectedImagePois$ | async) | sortBy_shared:'asc':'order', selectedPoi: (slideViewerFacade.currentSelectedImagePoi$ | async)}; as data) {
  @if (data.pois.length > 0) {
    <h3 class="pois-title my-3">{{"pois" | translate}}</h3>
    <div class="poi-list mt-2 mb-4">
      @for (poi of data.pois; track poi) {
        @if ({ active: data.selectedPoi === poi || (menuSharedFacade.showPrint$ | async) }; as collapsible) {
          <div class="card collapsible"
            [class.active]="collapsible.active">
            <!-- Header -->
            <div class="card-header"
              (click)="slideViewerFacade.requestSetPoiId(collapsible.active ? null : poi.id)">
              <h4 class="card-title mb-0"
                [ngClass]="[collapsible.active ? (slideViewerFacade.themeColor$ | async) : ''] ">
                {{ poi.name }}
              </h4>
            </div>
            <!-- Body -->
            @if (collapsible.active) {
              @if ({ annotationToPointOfInterests: poi.annotationToPointOfInterest | sortBy_shared:'asc':'order'}; as noteData) {
                <div class="card-body">
                  <!-- Notes -->
                  @if (poi.note) {
                    <div class="poi-notes">
                      <div class="poi-note">
                        <medsurf-text class="note-text" [text]="poi.note"></medsurf-text>
                      </div>
                    </div>
                  }
                  <!-- Annotations -->
                  @if (noteData.annotationToPointOfInterests.length > 0) {
                    <div class="poi-annotations mb-0"
                      >
                      @for (annotationToPointOfInterest of noteData.annotationToPointOfInterests; track annotationToPointOfInterest) {
                        @if ((slideViewerFacade.annotation(annotationToPointOfInterest.annotation) | async); as annotation) {
                          <button
                            class="annotation-link btn btn-link"
                            [ngClass]="(slideViewerFacade.themeColor$ | async)"
                            (click)="slideViewerFacade.requestSetAnnotationId(annotation.id)">
                            <i class="fa fa-fw fa-location-dot"></i>
                            @if ((slideViewerFacade.annotationLabel(annotation.label) | async); as label) {
                              <span>
                                {{ label.text }}
                              </span>
                            }
                          </button>
                        }
                      }
                    </div>
                  }
                </div>
              } @else {
                <div class="d-flex justify-content-center m-2">
                  <div class="spinner-border"></div>
                </div>
              }
            }
          </div>
        }
      }
    </div>
  }
} @else {
  <div class="d-flex justify-content-center m-2">
    <div class="spinner-border"></div>
  </div>
}
